import styled, { css } from "styled-components";

export const MyList = styled.div`
  border-bottom: 3px solid #3495ff;

  ${({ isActive }) =>
    isActive &&
    css`
      border-bottom-color: #fbd8ff;
    `}
`;

export const MyIcon = styled.img`
  width: ${({ w }) => w || "2.4rem"};
  border-radius: ${({ br }) => br || 0};
  object-fit: ${({ of }) => of || "contain"};
  margin-top: ${({ mt }) => mt || 0};
  margin-bottom: ${({ mb }) => mb || 0};
  margin-left: ${({ ml }) => ml || 0};
  margin-right: ${({ mr }) => mr || 0};

  ${({ h }) =>
    h &&
    css`
      height: ${h};
    `}
`;

export const MyImg = styled.img`
  width: ${({ width }) => width || "2.4rem"};
  border-radius: ${({ borderRadius }) => borderRadius || 0};
  object-fit: ${({ objectFit }) => objectFit || "contain"};
  margin-top: ${({ marginTop }) => marginTop || 0};
  margin-bottom: ${({ marginBottom }) => marginBottom || 0};
  margin-left: ${({ marginLeft }) => marginLeft || 0};
  margin-right: ${({ marginRight }) => marginRight || 0};

  ${({ height }) =>
    height &&
    css`
      height: ${height};
    `}
`;
